import NotFoundRoute from "PFApp/routes/not_found_route";
import { EnsureIsSaasAdmin, EnsureLoggedInAndRegistered, WithLayout } from "PFApp/routes/route_helpers";
import { admin } from "PFCore/base/page_layouts";
import DestroyAccountController from "PFModules/saas_admin/accounts/destroy/destroy_account_controller";
import EditAccountController from "PFModules/saas_admin/accounts/edit/edit_account_controller";
import AccountsCollectionController from "PFModules/saas_admin/accounts/list/accounts_collection_controller";
import ActivityTemplatesListController from "PFModules/saas_admin/activity_templates/list/activity_templates_list_controller";
import CustomizationController from "PFModules/saas_admin/customization/customization_controller";
import CvParsingConfController from "PFModules/saas_admin/cv_parsing_conf/cv_parsing_conf_controller";
import CvTemplateEditController from "PFModules/saas_admin/cv_templates/edit/cv_template_edit_controller";
import CvTemplatesCollectionController from "PFModules/saas_admin/cv_templates/list/cv_templates_collection_controller";
import FeaturesListController from "PFModules/saas_admin/features/list/features_list_controller";
import { FiltersConfigController } from "PFModules/saas_admin/filters_config/filters_config_controller";
import ImportsListController from "PFModules/saas_admin/imports/list/imports_list_controller";
import { LocalisationController } from "PFModules/saas_admin/localisation";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const SaasAdminRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedInAndRegistered>
      <EnsureIsSaasAdmin>
        <WithLayout layout={{ sidebar: admin }}>
          <Switch>
            <Route exact path={`${path}/accounts`}>
              <AccountsCollectionController />
            </Route>
            <Route path={`${path}/accounts/new`}>
              <EditAccountController />
            </Route>
            <Route path={`${path}/accounts/:accountId/edit`}>
              <EditAccountController />
            </Route>
            <Route path={`${path}/accounts/:accountId/destroy`}>
              <DestroyAccountController />
            </Route>
            <Route path={`${path}/accounts/:accountId/features`}>
              <FeaturesListController />
            </Route>
            <Route path={`${path}/accounts/:accountId/imports`}>
              <ImportsListController />
            </Route>
            <Route path={`${path}/accounts/:accountId/customization`}>
              <CustomizationController />
            </Route>
            <Route path={`${path}/accounts/:accountId/activity_templates`}>
              <ActivityTemplatesListController />
            </Route>
            <Route path={`${path}/accounts/:accountId/cv_parsing_conf`}>
              <CvParsingConfController />
            </Route>
            <Route path={`${path}/accounts/:accountId/cv_templates/new`}>
              <CvTemplateEditController />
            </Route>
            <Route path={`${path}/accounts/:accountId/cv_templates/:templateId/edit`}>
              <CvTemplateEditController />
            </Route>
            <Route path={`${path}/accounts/:accountId/filters`}>
              <FiltersConfigController />
            </Route>
            <Route path={`${path}/accounts/:accountId/cv_templates`}>
              <CvTemplatesCollectionController />
            </Route>
            <Route path={`${path}/accounts/:accountId/localisation`}>
              <LocalisationController />
            </Route>
            <Route path="*">
              <NotFoundRoute />
            </Route>
          </Switch>
        </WithLayout>
      </EnsureIsSaasAdmin>
    </EnsureLoggedInAndRegistered>
  );
};

export default SaasAdminRoutes;
